import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UuIdDTO } from '@app/landing-videoselfing/model/videoselfing-model';
import { VideoSelfingStore } from '@app/landing-videoselfing/services/videoselfing.store';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-consent-dialog',
  templateUrl: './videoselfing-consent-dialog.component.html',
  styleUrls: ['./videoselfing-consent-dialog.component.scss'],
})
export class VideoselfingConsentDialogComponent {
  @Input() show: boolean;
  @Input() uuId: UuIdDTO;
  @Output() isCancel = new EventEmitter<boolean>();

  constructor(private router: Router, private videoselfingStore: VideoSelfingStore) {}

  onClickAccept() {
    this.videoselfingStore.getOnfidoDate(this.uuId).then(
      (data) => {
        this.videoselfingStore.setApplicantId(data);
        this.videoselfingStore.postAcceptConsents(this.uuId).then((data) => {
          if (data) {
            this.router.navigate(['/landing-onfido-videoselfing']);
          }
        });
      },
      (error) => {
        console.error(error);
      }
    );
  }

  onClickCancel() {
    this.isCancel.emit(true);
  }
}
